'use client';

import { SignedUrls, Image } from '@/shared';
import { buildSrcSet } from '@/image-srcset';

export default function ImgClient({ image, signedUrls, placeholder, className, style, sizes, }: { image: Image, signedUrls: SignedUrls, placeholder: string, className?: string, style?: any, sizes?: string }) {
  const { width, height, alternativeText, } = image;
  const sizesAttr = sizes ?? `100vw`;
  const fallbackSrc = signedUrls.jpeg[signedUrls.jpeg.length - 1].url;

  return (
    <picture className={className}>
      <source srcSet={buildSrcSet(signedUrls.avif)} sizes={sizesAttr} type="image/avif" />
      <source srcSet={buildSrcSet(signedUrls.webp)} sizes={sizesAttr} type="image/webp" />
      <source srcSet={buildSrcSet(signedUrls.jpeg)} sizes={sizesAttr} type="image/jpeg" />
      <img
        alt={alternativeText}
        width={width}
        height={height}
        src={fallbackSrc}
        sizes={sizesAttr}
        style={{
          aspectRatio: `${width}/${height}`,
          maxWidth: `100%`,
          height: `auto`,
          backgroundSize: `cover`,
          backgroundImage: `url(${placeholder})`,
          ...style,
        }}
        decoding="async"
        loading="lazy"
      />
    </picture>
  );
}
